import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardContent } from '../components';
import { Plus, Filter, Search } from 'lucide-react';

export const InvestigationsPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const investigations: any[] = [];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-3xl font-bold text-white">Investigações</h1>
          <p className="text-gray-400">Gerenciar suas pesquisas e análises</p>
        </div>
        <Link to="/investigacoes/nova">
          <Button variant="primary" size="lg" className="flex items-center gap-2">
            <Plus className="w-5 h-5" />
            Nova Investigação
          </Button>
        </Link>
      </div>

      {/* Filtros e Busca */}
      <Card>
        <CardContent className="space-y-4">
          <div className="flex gap-4 flex-col md:flex-row">
            <div className="flex-1 relative">
              <Search className="absolute left-3 top-3 w-5 h-5 text-gray-500" />
              <input
                type="text"
                placeholder="Buscar investigação..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
            <Button variant="secondary" className="flex items-center gap-2">
              <Filter className="w-5 h-5" />
              Filtros
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Lista ou Estado Vazio */}
      {investigations.length === 0 ? (
        <Card>
          <CardContent className="text-center py-12">
            <Search className="w-12 h-12 text-gray-600 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-white mb-2">Nenhuma investigação encontrada</h3>
            <p className="text-gray-400 mb-6">Comece criando sua primeira investigação.</p>
            <Link to="/investigacoes/nova">
              <Button variant="primary">Nova Investigação</Button>
            </Link>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-3">
          {investigations.map((inv) => (
            <Card key={inv.id} className="cursor-pointer hover:border-blue-800 transition-colors">
              <CardContent className="flex justify-between items-start py-6">
                <div>
                  <h3 className="font-semibold text-white">{inv.title}</h3>
                  <p className="text-sm text-gray-400 mt-1">{inv.purpose}</p>
                  <p className="text-xs text-gray-500 mt-2">
                    Iniciada em {new Date(inv.started_at).toLocaleDateString('pt-BR')}
                  </p>
                </div>
                <span
                  className={`px-3 py-1 rounded text-xs font-medium whitespace-nowrap ${
                    inv.status === 'concluida'
                      ? 'bg-green-900 text-green-200'
                      : inv.status === 'em_progresso'
                      ? 'bg-amber-900 text-amber-200'
                      : inv.status === 'erro'
                      ? 'bg-red-900 text-red-200'
                      : 'bg-gray-800 text-gray-200'
                  }`}
                >
                  {inv.status}
                </span>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};
